import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { toogleReload } from '../../../Utils/reloadSlice';
import { toogleEmotionAdd } from '../../../Utils/emotionAddSlice';
import { FaPause, FaPlay } from 'react-icons/fa';

const AddEmotion = () => {
    const dispatch = useDispatch();
    const [heading, setHeading] = useState("");
    const [category, setCategory] = useState("");
    const [image, setImage] = useState("");
    const [aud, setAud] = useState(null);
    const [lyrics, setLyrics] = useState([]);
    const [loading, setLoading] = useState(false);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const textRefs = useRef([]);
    const [heights, setHeights] = useState([]);
    const [newLyrics, setNewLyrics] = useState("");
    const [newTime, setNewTime] = useState("");
    const [addLyrics, setAddLyrics] = useState(false);
    const [alert, setAlert] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editedText, setEditedText] = useState('');
    const [editedTime, setEditedTime] = useState('');

    useEffect(() => {
        const newHeights = textRefs.current.map(ref => ref ? ref.clientHeight : 0);
        setHeights(newHeights);
    }, [lyrics]);

    const handlePlayPause = () => {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const handleLoadedMetadata = () => {
        setDuration(audioRef.current.duration);
    };

    const handleSeek = (event) => {
        const seekTime = (event.target.value / 100) * duration;
        audioRef.current.currentTime = seekTime;
        setCurrentTime(seekTime);
    };

    useEffect(() => {
        if(aud !== null){
            const audio = audioRef.current;
            audio.addEventListener('timeupdate', handleTimeUpdate);
            audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    
            return () => {
                audio.removeEventListener('timeupdate', handleTimeUpdate);
                audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, []);

    const toggleEmotionAddHandler = () => {
        dispatch(toogleEmotionAdd());
        setHeading("");
        setCategory("");
        setAud(null);
        setLoading(false);
    }

    const uploadFile = async (type) => {
        const data = new FormData();
        data.append("file", type === "image" ?  image : aud);
        data.append("upload_preset", type === "image" ? 'app_image_preset' : 'emotion_preset');
    
        try{
          const resourceType = type === 'image'? 'image' : 'video';
          const api = `https://api.cloudinary.com/v1_1/ddbrxrvat/${resourceType}/upload`;
          const res = await axios.post(api, data);
          const { secure_url } = res.data;
          return secure_url;
        } catch (err) {
          console.log(err);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            setLoading(true);
            const imgUrl = await uploadFile('image');
            const audUrl = await uploadFile();
            await fetch(`https://app-api.mokx.org/api/v1/emotion`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "heading": heading,
                    "category": category,
                    "emotionLink": audUrl,
                    "emotionLyrics": lyrics,
                    "emotionImage": imgUrl
                }),
            });
            dispatch(toogleEmotionAdd());
            setHeading("");
            setCategory("");
            setAud(null);
            dispatch(toogleReload())
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const handleAdd = () => {
        if(newLyrics !== "" && newTime !== ""){
            const timeInMilliseconds = newTime.split(':').reduce((acc, time) => (60 * acc) + +time) * 1000;
            setLyrics([...lyrics, { text: newLyrics, time: timeInMilliseconds }]);
            setAddLyrics(false);
            setNewLyrics("");
            setNewTime("");
            setAlert(false);
        }else{
            setAlert(true);
        }
    };

    const formatTimeForInput = (milliseconds) => {
        const date = new Date(milliseconds);
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    const handleEditClick = (index, item) => {
        setEditIndex(index);
        setEditedText(item.text);
        setEditedTime(formatTimeForInput(item.time));
    };

    const handleSaveClick = (index) => {
        const timeInMilliseconds = editedTime.split(':').reduce((acc, time) => (60 * acc) + +time) * 1000;
        for (let i = 0; i < lyrics.length; i++) {
            if (i === index) {
              lyrics[i].text = editedText;
              lyrics[i].time = timeInMilliseconds;
              break;
            }
        }
        setEditIndex(null);
    };

    return (
        <>
            <div tabIndex="-1" className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                <div className="relative w-full max-w-lg max-h-full mx-auto">
                    <div className="relative bg-white rounded-lg shadow">
                        <div className='flex items-center justify-between px-6 py-4'>
                            <h1 className='text-[#231F20] text-xl leading-8 font-figtree font-semibold'>Add Emotion</h1>
                            <button type="button" className="text-[#999CA0]" onClick={() => toggleEmotionAddHandler()}>
                                <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                            </button>
                        </div>
                        <div className='w-full h-[1px] bg-[#F2F2F2]'></div>
                        <div className='p-6 flex flex-col gap-6'>
                            <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                                <div className='flex flex-col'>
                                    <label htmlFor="heading" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Heading<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            required
                                            type="text"
                                            name="heading"
                                            onChange={(e) => setHeading(e.target.value)}
                                            value={heading}
                                            placeholder='Eg. Bhagvad Gita 2.56'
                                            className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-col'>
                                    <label htmlFor="category" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Category<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-fulll px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            required
                                            type="text"
                                            name="category"
                                            onChange={(e) => setCategory(e.target.value)}
                                            value={category}
                                            placeholder='Eg. Anger Management'
                                            className='w-ful text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-col'>
                                    <label htmlFor="image" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Image<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            required
                                            type="file"
                                            name="image"
                                            onChange={(e) => setImage((prev) => e.target.files[0])}
                                            accept="image/*"
                                            className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                    {image!== "" && <div className=' flex justify-center items-center mt-2'>
                                        <img className='w-20 h-20' src={URL.createObjectURL(image)} alt='' />
                                    </div>}
                                </div>
                                <div className='flex flex-col'>
                                    <label htmlFor="audio" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Select Audio<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            required
                                            type="file"
                                            name="audio"
                                            onChange={(e) => setAud((prev) => e.target.files[0])}
                                            accept="audio"
                                            className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                </div>
                                {aud !== null && <div className="audio-player mb-4">
                                    <audio
                                        ref={audioRef}
                                        className="hidden"
                                        onTimeUpdate={handleTimeUpdate}
                                        onLoadedMetadata={handleLoadedMetadata}
                                    >
                                        <source src={URL.createObjectURL(aud)} type="video/mp4" />
                                        Your browser does not support the audio element.
                                    </audio>
                                    <div className="flex items-center justify-between w-full gap-3">
                                        <div onClick={handlePlayPause} className="p-2 rounded-full bg-blue-500 text-white">
                                            {isPlaying ? <FaPause /> : <FaPlay />}
                                        </div>
                                        <input
                                            type="range"
                                            value={(currentTime / duration) * 100 || 0}
                                            onChange={handleSeek}
                                            className="w-[60%]"
                                        />
                                        <span className="text-xs text-gray-500">
                                            {formatPlayerTime(currentTime)} / {formatPlayerTime(duration)}
                                        </span>
                                    </div>
                                </div>}
                                {lyrics.map((item, index) => (
                                    <div key={index} className="w-full bg-[#FFA500] rounded-lg border border-[#F2F2F2] px-1 py-1 flex gap-1 justify-between items-center" style={{ height: heights[index]+16 }} >
                                        {editIndex === index ? (<>
                                            <div className='w-full rounded-lg'>
                                                <input
                                                    type="text"
                                                    name="editlyrics"
                                                    onChange={(e) => setEditedText(e.target.value)}
                                                    value={editedText}
                                                    placeholder='Edit lyrics....'
                                                    className='w-full rounded-lg text-[#000000] px-1 text-base font-figtree font-normal focus:outline-none'
                                                    style={{ height: heights[index] + 4 }}
                                                />
                                            </div>
                                            <div className='rounded-lg'>
                                                <input
                                                    type="time"
                                                    step={1}
                                                    name="edittime"
                                                    onChange={(e) => setEditedTime(e.target.value)}
                                                    value={editedTime}
                                                    className='w-full rounded-lg text-[#000000] px-1 text-base font-figtree font-normal focus:outline-none'
                                                    style={{ height: heights[index] + 4 }}
                                                />
                                            </div>
                                            <div className='rounded-md bg-clip flex justify-center items-center cursor-pointer' style={{ height: heights[index] + 4 }} onClick={() => handleSaveClick(index)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48">
                                                    <g fill="none" strokeLinejoin="round" strokeWidth="4">
                                                        <rect width="36" height="36" x="6" y="6" fill="url(#grad1)" stroke="url(#grad1)" rx="3"/>
                                                        <path stroke="#fff" strokeLinecap="round" d="M24 16V32"/>
                                                        <path stroke="#fff" strokeLinecap="round" d="M16 24L32 24"/>
                                                        <defs>
                                                            <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                                                                <stop offset="0%" stop-color= "#4285F4" stop-opacity= "1" />
                                                                <stop offset="100%" stop-color= "#286DE0" stop-opacity= "1" />
                                                            </linearGradient>
                                                        </defs>
                                                    </g>
                                                </svg>
                                            </div>
                                        </>)
                                        : (<>
                                            <span ref={(el) => (textRefs.current[index] = el)} className="bg-[#F8FAFF] border-[2px] border-[#F8FAFF] rounded-md px-1 w-full drop-shadow-xl" >
                                                {item.text}
                                            </span>
                                            <div className="flex items-center gap-1">
                                                <div className="bg-[#F8FAFF] border-[2px] border-[#F8FAFF] rounded-md px-1 py-[2px] h-full flex items-center drop-shadow-xl" style={{ height: heights[index] + 4 }} >
                                                    {formatTime(item.time)}
                                                </div>
                                                <div className="w-6 bg-[#F34522] rounded-md flex justify-center items-center cursor-pointer drop-shadow-xl" style={{ height: heights[index] + 4 }} onClick={() => setLyrics(prevLyrics => prevLyrics.filter((_, i) => i !== index))}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                        <path fill="#FFF" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12l1.41 1.41L13.41 14l2.12 2.12l-1.41 1.41L12 15.41l-2.12 2.12l-1.41-1.41L10.59 14zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>
                                                    </svg>
                                                </div>
                                                <div className="w-6 bg-clip rounded-md flex justify-center items-center cursor-pointer drop-shadow-xl" style={{ height: heights[index] + 4 }} onClick={() => handleEditClick(index, item)} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                                        <path fill="#FFF" d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83l3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </>)}
                                    </div>
                                ))}
                                {addLyrics && <>
                                    <div className='flex gap-1'>
                                        <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                            <input
                                                type="text"
                                                name="newlyrics"
                                                onChange={(e) => setNewLyrics(e.target.value)}
                                                value={newLyrics}
                                                placeholder='Add new lyrics....'
                                                maxLength={75}
                                                className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                            />
                                        </div>
                                        <div className='rounded-lg px-4 py-3 border border-[#F2F2F2]'>
                                            <input
                                                type="time"
                                                step={1}
                                                name="newtime"
                                                onChange={(e) => setNewTime(e.target.value)}
                                                value={newTime}
                                                className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                            />
                                        </div>
                                        <div className='rounded-md flex justify-center items-center cursor-pointer' onClick={handleAdd}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="0 0 48 48">
                                                <g fill="none" strokeLinejoin="round" strokeWidth="4">
                                                    <rect width="36" height="48" x="6" y="0" fill="url(#grad1)" stroke="url(#grad1)" rx="3"/>
                                                    <path stroke="#fff" strokeLinecap="round" d="M24 16V32"/>
                                                    <path stroke="#fff" strokeLinecap="round" d="M16 24L32 24"/>
                                                    <defs>
                                                        <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                                                            <stop offset="0%" stop-color= "#4285F4" stop-opacity= "1" />
                                                            <stop offset="100%" stop-color= "#286DE0" stop-opacity= "1" />
                                                        </linearGradient>
                                                    </defs>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className='flex justify-between -mt-5 px-2'>
                                        <div className='text-[#919090]  text-sm font-figtree font-medium'>{newLyrics.length}/75</div>
                                        {alert && <div className='text-[#ff1212] text-sm font-figtree font-medium'>Please add Lyrics and Time both!</div>}
                                    </div>
                                </>
                                }
                                {!addLyrics && <div className='w-full rounded-md flex justify-center items-center cursor-pointer' onClick={() => {setAddLyrics(true)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48">
                                        <g fill="none" strokeLinejoin="round" strokeWidth="4">
                                            <rect width="36" height="36" x="6" y="6" fill="url(#grad1)" stroke="url(#grad1)" rx="3"/>
                                            <path stroke="#fff" strokeLinecap="round" d="M24 16V32"/>
                                            <path stroke="#fff" strokeLinecap="round" d="M16 24L32 24"/>
                                            <defs>
                                                <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                                                    <stop offset="0%" stop-color= "#4285F4" stop-opacity= "1" />
                                                    <stop offset="100%" stop-color= "#286DE0" stop-opacity= "1" />
                                                </linearGradient>
                                            </defs>
                                        </g>
                                    </svg>
                                </div>}
                                <div className='w-full h-[0.5px] bg-[#F2F2F2]'></div>
                                <div className='text-center'>
                                    <button type="submit" disabled={loading} className='w-[24%] bg-clip disabled:opacity-50 rounded-[8px] px-4 py-2 text-[#FFF] text-sm font-figtree font-semibold'>
                                        {!loading ? 'Submit' : 'Uploading'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full bg-[#282c3f]/[0.5] fixed top-0 left-0 z-[49]'></div>
        </>
    )
}

const formatTime = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = ((milliseconds % 60000) / 1000).toFixed(0);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
  
const formatPlayerTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export default AddEmotion;